var _path, _mask, _path2, _mask2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 739,
    viewBox: "0 0 361 739",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.154 378.656L0 514.634V362.196L180.846 225.695V360.978L361 225V377.438L180.154 513.939V378.656Z",
    fill: "#f8d24a"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_14_9505",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.154 88.6557L0 224.634V72.1962L180.846 -64.3048V70.978L361 -65V87.4376L180.154 223.939V88.6557Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.154 88.6557H181.154V86.648L179.551 87.8576L180.154 88.6557ZM0 224.634H-1V226.641L0.602444 225.432L0 224.634ZM0 72.1962L-0.602444 71.398L-1 71.6981V72.1962H0ZM180.846 -64.3048H181.846V-66.3124L180.244 -65.1029L180.846 -64.3048ZM180.846 70.978H179.846V72.9857L181.449 71.7762L180.846 70.978ZM361 -65H362V-67.0077L360.398 -65.7982L361 -65ZM361 87.4376L361.602 88.2357L362 87.9357V87.4376H361ZM180.154 223.939H179.154V225.946L180.756 224.737L180.154 223.939ZM179.551 87.8576L-0.602444 223.836L0.602444 225.432L180.756 89.4539L179.551 87.8576ZM1 224.634V72.1962H-1V224.634H1ZM0.602444 72.9943L181.449 -63.5066L180.244 -65.1029L-0.602444 71.398L0.602444 72.9943ZM179.846 -64.3048V70.978H181.846V-64.3048H179.846ZM181.449 71.7762L361.602 -64.2018L360.398 -65.7982L180.244 70.1799L181.449 71.7762ZM360 -65V87.4376H362V-65H360ZM360.398 86.6394L179.551 223.14L180.756 224.737L361.602 88.2357L360.398 86.6394ZM181.154 223.939V88.6557H179.154V223.939H181.154Z",
    fill: "white",
    fillOpacity: 0.95,
    mask: "url(#path-2-inside-1_14_9505)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_14_9505",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.154 668.656L0 804.634V652.196L180.846 515.695V650.978L361 515V667.438L180.154 803.939V668.656Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.154 668.656H181.154V666.648L179.551 667.858L180.154 668.656ZM0 804.634H-1V806.641L0.602444 805.432L0 804.634ZM0 652.196L-0.602444 651.398L-1 651.698V652.196H0ZM180.846 515.695H181.846V513.688L180.244 514.897L180.846 515.695ZM180.846 650.978H179.846V652.986L181.449 651.776L180.846 650.978ZM361 515H362V512.992L360.398 514.202L361 515ZM361 667.438L361.602 668.236L362 667.936V667.438H361ZM180.154 803.939H179.154V805.946L180.756 804.737L180.154 803.939ZM179.551 667.858L-0.602444 803.836L0.602444 805.432L180.756 669.454L179.551 667.858ZM1 804.634V652.196H-1V804.634H1ZM0.602444 652.994L181.449 516.493L180.244 514.897L-0.602444 651.398L0.602444 652.994ZM179.846 515.695V650.978H181.846V515.695H179.846ZM181.449 651.776L361.602 515.798L360.398 514.202L180.244 650.18L181.449 651.776ZM360 515V667.438H362V515H360ZM360.398 666.639L179.551 803.14L180.756 804.737L361.602 668.236L360.398 666.639ZM181.154 803.939V668.656H179.154V803.939H181.154Z",
    fill: "white",
    fillOpacity: 0.95,
    mask: "url(#path-4-inside-2_14_9505)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash);
export default __webpack_public_path__ + "static/media/splash.5e009f8eb6dda555cdf72c235aa8ab69.svg";
export { ForwardRef as ReactComponent };